module.exports = __webpack_public_path__ + "img/ic_visa_conversion.6f2d6fd3.png";